export default __webpack_public_path__ + "static/media/sticker-u.0da91013.png";